import _extends from "@babel/runtime/helpers/extends";
import { ONOTYImage as Base } from "@cancer-council-queensland/react";
import { jsx as _jsx } from "react/jsx-runtime";
export var ONOTYImage = props => /*#__PURE__*/_jsx(Base, _extends({}, props));
//# sourceMappingURL=onoty_image.js.map